import {Presenter} from '../../../../../Support/with_presenter';
import {Duration} from '../../../../../Domain/Duration';
import {Crew} from '../../../../../Models/Crew';
import {zonedTimeToUtc} from 'date-fns-tz';
import {EventsInteractor} from '../../../../../Calendar/EventsInteractor';
import {Frequency, RecurrenceRule} from '../../../../../Models/ScheduledEvent';

export class CreateScheduledEventPresenter implements Presenter {
    public crew: Crew;
    public time: string = '17:00';
    public startAt: Date | null;
    public duration: Duration | null = Duration.fromMinutes(60);
    public title: string = '';
    public frequency: Frequency | null = null;
    public description: string = '';

    public frequencyOptions = {
        [Frequency.Daily]: 'Daily',
        [Frequency.Weekly]: 'Weekly',
        [Frequency.Monthly]: 'Monthly',
    };

    public get validates(): boolean {
        return this.title.length > 0 && this.description.length > 0 && this.startAt !== null && this.duration !== null;
    }

    public get timeOptions(): string[] {
        //Returns a list from 00:00 to 23:45 in 15 minute increments
        const timeOptions: string[] = [];
        for (let i = 0; i < 24; i++) {
            for (let j = 0; j < 4; j++) {
                timeOptions.push(`${i.toString().padStart(2, '0')}:${(j * 15).toString().padStart(2, '0')}`);
            }
        }

        return timeOptions;
    }

    constructor(
        crews: Crew[],
        initialDate: Date | null,
        private onFinish: () => void,
        private eventsInteractor: EventsInteractor,
    ) {
        initialDate?.setHours(17, 0, 0, 0);
        this.startAt = initialDate ?? null;
        this.crew = crews[0];
    }

    public mount(): void {
        /* Noop */
    }

    public unmount(): void {
        /* Noop */
    }

    public setCrew(crew: Crew): void {
        this.crew = crew;
    }

    public setTitle(title: string): void {
        this.title = title;
    }

    public setTime(time: string): void {
        this.time = time;
    }

    public setStartAt(startAt: Date | null): void {
        this.startAt = startAt;
    }

    public setDuration(duration: Duration | null): void {
        this.duration = duration;
    }

    public setFrequency(frequency: Frequency | null): void {
        this.frequency = frequency;
    }

    public setDescription(description: string): void {
        this.description = description;
    }

    public async onSubmit(): Promise<void> {
        try {
            const startAt = zonedTimeToUtc(
                `${this.startAt!.toISOString().split('T')[0]}T${this.time}:00`,
                this.crew.timezone,
            );

            const recurrenceRule: RecurrenceRule | null =
                this.frequency !== null
                    ? {
                          frequency: this.frequency,
                          endAt: null,
                      }
                    : null;

            await this.eventsInteractor.create(
                this.crew.id,
                this.title,
                this.description,
                startAt!,
                this.duration!,
                recurrenceRule,
            );
            this.onFinish();
        } catch (e) {
            //TODO
        }
    }
}
